import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";
import MobileBar from "@/components/public/MobileBar";
import { SectionLabel, Reveal, WhatsAppButton } from "@/components/public/shared";
import { useEnquiry } from "@/components/public/EnquiryProvider";

export default function PublicLayout() {
  const loc = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main className="pb-16 lg:pb-0"><Outlet /></main>
      <BiggerCTA />
      <Footer />
      <MobileBar />
      <WhatsAppButton />
    </div>
  );
}

export function PageHero({ label, title, subtitle, image }) {
  return (
    <section className="relative flex min-h-[70vh] items-end overflow-hidden pt-24">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="h-full w-full object-cover animate-ken-burns" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/50 to-charcoal/20" />
      </div>
      <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
        <Reveal>
          <SectionLabel className="text-gold [&_span]:text-gold">{label}</SectionLabel>
          <h1 className="mt-5 max-w-4xl font-display text-4xl font-light leading-[1.05] text-white sm:text-5xl lg:text-6xl">{title}</h1>
          {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}

export function BiggerCTA() {
  const { open } = useEnquiry();
  return (
    <section className="relative overflow-hidden bg-espresso py-20 sm:py-28">
      <div className="absolute inset-0 grain opacity-[0.06]" />
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
        <Reveal>
          <div className="mx-auto mb-6 flex w-fit items-center gap-3">
            <span className="h-px w-8 bg-gold" />
            <span className="text-[11px] font-semibold uppercase tracking-editorial text-gold">Planning Something Bigger?</span>
            <span className="h-px w-8 bg-gold" />
          </div>
          <h2 className="font-display text-3xl font-light text-ivory sm:text-4xl lg:text-5xl">
            For weddings, celebrations, corporate events or recurring food service
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-ivory/70">
            Speak with our hospitality team and let us craft an experience around your occasion, organisation or institution.
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <button data-testid="cta-event-catering" onClick={() => open("event")}
              className="w-full rounded-none bg-gold px-8 py-4 text-[12px] font-semibold uppercase tracking-editorial text-charcoal transition-colors hover:bg-ivory sm:w-auto">
              Event Catering
            </button>
            <button data-testid="cta-bulk-services" onClick={() => open("bulk")}
              className="w-full rounded-none border border-ivory/40 px-8 py-4 text-[12px] font-semibold uppercase tracking-editorial text-ivory transition-colors hover:border-gold hover:text-gold sm:w-auto">
              Bulk Food Services
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
